export class ConfirmService {
    constructor($uibModal) {
        this.$uibModal = $uibModal;
    }

    confirm(message, title) {
        return this.$uibModal.open({
            templateUrl: 'app/shared/confirm.html',
            controller: 'ConfirmController',
            controllerAs: 'vm',
            resolve: {
                message: function() {
                    return message;
                },
                title: function() {
                    return title;
                }
            }
        }).result;
    }
}

ConfirmService.$inject = ['$uibModal'];